import { useEffect, useRef } from 'react';
import { graphql, useFragment } from 'react-relay';
import isEqual from 'lodash/isEqual.js';
import {
    type PrerenderedCheckoutParams,
    updatePrerenderedCheckoutParams,
    getPrerenderedCheckoutState,
} from './prerenderedCheckoutStore.ts';
import { redirectToPrerenderedCheckout } from './redirectToPrerenderedCheckout.ts';
import { type usePrerenderedCheckout_item$key } from './__generated__/usePrerenderedCheckout_item.graphql.ts';

const itemFragment = graphql`
    fragment usePrerenderedCheckout_item on Item {
        ...redirectToPrerenderedCheckout_item
    }
`;

export type UsePrerenderedCheckoutParams = {
    item: usePrerenderedCheckout_item$key | null | undefined;
    hideParentPage: () => void;
    params: PrerenderedCheckoutParams;
};

export const usePrerenderedCheckout = ({
    item: itemRef,
    hideParentPage,
    params,
}: UsePrerenderedCheckoutParams): {
    redirect: () => void;
} => {
    const item = useFragment(itemFragment, itemRef);
    const ref = useRef<PrerenderedCheckoutParams>({});

    useEffect(() => {
        if (!isEqual(ref.current, params)) {
            ref.current = params;
            updatePrerenderedCheckoutParams(params);
        }
    });

    return {
        redirect: () =>
            redirectToPrerenderedCheckout({
                item,
                hideParentPage,
                params: {
                    ...getPrerenderedCheckoutState().params,
                    triggerType:
                        ref.current?.triggerType ||
                        getPrerenderedCheckoutState().params?.triggerType,
                },
                isUserComesFromEmail: false,
            }),
    };
};
